import { LinkPayLaterURI, LinkablePayLater } from "@payment-client/interfaces/PublicPayLater";

// PayLater URI constants for endpoint mappings
export const LINK_PAYLATER_URI: LinkPayLaterURI = {
    [LinkablePayLater.LAZYPAY]: {
        isLinked: "/api/v3/paylater/lazypay/isLinked",
        link: "/api/v3/paylater/lazypay/link",
        delink: "/api/v3/paylater/lazypay/delink",
        validateOtp: "/api/v3/paylater/lazypay/validate",
        resendOtp: "/api/v3/paylater/lazypay/resendOtp",
        creditLimit: "",
    },
    [LinkablePayLater.SIMPL]: {
        isLinked: "", // For Simpl, we never use the isLinked endpoint. But in order to match the structure of other existing paylater options, we added this field and left it empty.
        link: "",
        delink: "/api/v3/paylater/simpl/delink",
        validateOtp: "",
        resendOtp: "",
        creditLimit: "",
    },
    [LinkablePayLater.AMAZONPAYLATER]: {
        isLinked: "",
        link: "",
        delink: "",
        validateOtp: "",
        resendOtp: "",
        creditLimit: "/api/v1/user/apay/getBalance",
    },
};
